<template>
  <a-card :bordered="false">
    <SmallSquare class='m-b-45' content='数据统计到昨日数据，数据每天00：00自动更新' />
    <div class="data-content-nav s_flex_ali">

      <div class="data-content-nav-item flex_1 s_flex_center" :class="type=='award_user'?'activeType':''" @click="changNav('award_user')">
        <div>
          <p class='title'>中奖人数 <a-tooltip placement='right'>
              <template #title>通过导购活动中奖人数，去重
              </template>
              <InfoCircleOutlined class="s_c376 fz-14" />
            </a-tooltip>
          </p>
          <p class="fz-16"><img src="@/assets/images/customer/yestody.png" alt="">{{detailData.yesterdaystatistics.award_user || 0}}</p>
          <p class="fz-16"><img src="@/assets/images/customer/total.png" alt="">{{detailData.statistics.award_user || 0}}</p>
        </div>
      </div>
      <div class="data-content-nav-item flex_1 s_flex_center" :class="type=='award_number'?'activeType':''" @click="changNav('award_number')">
        <div>
          <p class='title'>奖项发放数量 <a-tooltip placement='right'>
              <template #title>统计成功领取奖项的次数
              </template>
              <InfoCircleOutlined class="s_c376 fz-14" />
            </a-tooltip>
          </p>
          <p class="fz-16"><img src="@/assets/images/customer/yestody.png" alt="">{{detailData.yesterdaystatistics.award_number || 0}}</p>
          <p class="fz-16"><img src="@/assets/images/customer/total.png" alt="">{{detailData.statistics.award_number || 0}}</p>
        </div>
      </div>
      <div class="data-content-nav-item flex_1 s_flex_center" :class="type=='point_num'?'activeType':''" @click="changNav('point_num')">
        <div>
          <p class='title'>发放积分数量 <a-tooltip placement='right'>
              <template #title>通过导购活动派发的积分数量
              </template>
              <InfoCircleOutlined class="s_c376 fz-14" />
            </a-tooltip>
          </p>
          <p class="fz-16"><img src="@/assets/images/customer/yestody.png" alt="">{{detailData.yesterdaystatistics.point_num || 0}}
          </p>
          <p class="fz-16"><img src="@/assets/images/customer/total.png" alt="">{{detailData.statistics.point_num || 0}}</p>
        </div>
      </div>
      <div class="data-content-nav-item flex_1 s_flex_center" :class="type=='bonus_num'?'activeType':''" @click="changNav('bonus_num')">
        <div>
          <p class='title'>发放红包数量 <a-tooltip placement='right'>
              <template #title>通过导购活动派发的红包金额，保留两位小数
              </template>
              <InfoCircleOutlined class="s_c376 fz-14" />
            </a-tooltip>
          </p>
          <p class="fz-16"><img src="@/assets/images/customer/yestody.png" alt="">{{detailData.yesterdaystatistics.bonus_num || 0}}
          </p>
          <p class="fz-16"><img src="@/assets/images/customer/total.png" alt="">{{detailData.statistics.bonus_num || 0}}</p>
        </div>
      </div>
    </div>
        <div class="m-t-60 s_po_re" style="min-height:420px">
      <div class=" s_over_h p-r-40 ">
        <div class="fr s_flex_ali s_bor3 s_over_h">
          <div class="day_active"  :class="{ active: active == 7 }"  @click="changeTime(7)"> 近7天</div>
          <div class="day_active" :class="{ active: active == 30 }" @click="changeTime(30)">近30天</div>
        </div>
      </div>
      <a-spin tip="Loading..."  :spinning="Loading">
         <lineChart ref="myChart" v-show="!Loading"></lineChart>
      </a-spin>
    </div>
  </a-card>
</template>

<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { onMounted, reactive, ref, toRefs } from "vue";
import lineChart from "./components/lineChart.vue";
import {showSurvey,scan_statistical} from '@/api/guide.js'
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
export default {
  components: {
    lineChart,
    InfoCircleOutlined
  },
  setup() {
    const myChart = ref(null);
    const state = reactive({
      type:'award_user',
      active: 7,
      echartDate: {
      },
      detailData:{
        statistics:{},
        yesterdaystatistics:{}
      },
      Loading:false
    });

    const changeTime = function (val) {
      state.active=val
      getGeneral()
    };

    //获取数据
    const getGeneral = async function(){
        state.Loading = true;
        let res = await scan_statistical({day:state.active,type:state.type}).then(res=>res.data);
        if(iscode(res)){
           myChart.value.renderEcharts(res.data); //折线图
           state.Loading = false;
        }else{
          state.Loading = false;
           message.error(res.msg)
        }
    }
    const initData=async ()=>{
        let res = await showSurvey({day:state.active,type:state.type}).then(res=>res.data);
        if(iscode(res)){
            state.detailData=res.data
        }
    }
    const changNav=(type)=>{
      state.type=type
      initData()
      getGeneral()
    }

    onMounted(() => {
      getGeneral()
      initData()
    });
    return {
      ...toRefs(state),
      myChart,
      changeTime,
      changNav
    };
  },
};
</script>
<style lang="less" scoped>
.day_active {
  width: 100px;
  height: 40px;
  background: #fff;
  color: #333;
  border: 1px solid #cecece;
  text-align: center;
  line-height: 40px;
  // margin-left: -1px;
  cursor: pointer;
}
.active {
  background: #143960;
  color: #fff;
  border: none;
  cursor: pointer;
}
.data-content-nav {
  background: #fbfcfc;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 30px;
    padding-bottom: 30px;
    cursor: pointer;
    transition: all .3s;
    .title {
      font-size: 18px;
      color: #000000;
      margin-bottom:10px
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }

    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
    }
  }
}
.activeType{
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(0,0,0,.3);
  border-radius: 20px;
}
</style>